import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router';
import { Header } from './Header';
import { Footer } from './Footer';
import { AppDataContext } from "./AppDataContext"
import useNetwork from '../useNetwork';
import { ToastContainer } from 'react-toastify';


export function Layout(props) {

    const context = useContext(AppDataContext);
    const { loading, networkError, netRequest, netRenderError } = useNetwork(true);


    //if (networkError) {
    //    //return netRenderError();
    //    if (networkError === "Unauthorized") {
    //        return <Redirect to="/login" />;
    //    }
    //    return <Redirect to="/error" status={networkError} />

    //}
    //if (loading)
    //    return <></>

    return (
        <>
            <Header />
            {props.children}
            <Footer />

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </>
    );

}
